import { render } from "./Article.view.vue?vue&type=template&id=964b6892"
import script from "./Article.view.vue?vue&type=script&lang=js"
export * from "./Article.view.vue?vue&type=script&lang=js"

import "./Article.view.vue?vue&type=style&index=0&id=964b6892&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__